// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import ConvoyMenu from './ConvoyMenu'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectAu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }

    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='9' />
                <div className='dv_project_body'>
                    <ConvoyMenu activeMenu={6} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/55_000025.jpg")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>B1. U-Path课程</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>B2. 国际本科类</div>
                                    <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>教育部SQA项目</div>
                                    <div className={this.state.currentTab == 3 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(3)}>B3. 本硕直通项目</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000026.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000027.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000028.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>
                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000029.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000030.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>
                                </div>}
                                {this.state.currentTab == 2 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000031.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000032.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000033.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000034.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000035.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>
                                </div>}
                                {this.state.currentTab == 3 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000036.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000037.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000038.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000039.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000040.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000041.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000042.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000043.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        );
    }
}

export default withRouter(ProjectAu);